module.exports = __webpack_public_path__ + "static/media/Cheque_Book_Request_Status.116b88f8.svg";